import { http, httpFile } from './http_service';

//Get all
export function all(){
    return http().get('/document-type');
}
//Get all active
export function allActive(){
    return http().get('/document-type/active');
}
//Get Single
export function single(id){
    return http().get(`/document-type/${id}`);
}
//Add one
export function add(data){
    return http().post('/document-type', data)
}
//Update
export function update(id, data){
    return http().put(`/document-type/${id}`, data)
}
//Delete one
export function deleteSingle(id){
    return http().delete(`/document-type/${id}`);
}